module.exports = __webpack_public_path__ + "static/media/Rodapies-v2.2e6e2b1e.png";